// Access helpers for the UI. The DATABASE is the authority (RLS + app.module_access);
// these only decide what to show, so a hidden button is never the only protection.
import type { Access, ModuleAccess } from "./api/types";

export const canView = (a: Access | undefined | null): boolean => a === "view" || a === "edit";
export const canEdit = (a: Access | undefined | null): boolean => a === "edit";

/** Modules to list in the project sidebar: switched on and viewable. Placeholders ("soon") stay visible but disabled. */
export function sidebarModules(mods: ModuleAccess[]): { id: string; name: string; state: "open" | "soon" }[] {
  return mods
    .filter((m) => canView(m.access) || m.enabled === false)
    .map((m) => ({ id: m.id, name: m.name, state: m.enabled === false ? "soon" : "open" }));
}
